import React, { useEffect, useState, useContext } from 'react';

import {useNavigate,useParams } from 'react-router-dom';
import axios from "axios";

import FullCardGrid from '../GridViewMain/FullCardGrid/FullCardGrid';
import translations from '../../utils/language/translations.json'
import { useTranslation } from 'react-i18next';


const WantListViewer = () => {
  const { listId } = useParams(); // Extracts listId from URL
  const [cards, setCards] = useState([]); // Store fetched cards
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchCollection = async () => {
      try {
        if (!listId) {
          setError("No list ID provided.");
          return;
        }

        // Fetch only the array of userCardIds
        const collectionResponse = await axios.get(
          `${process.env.REACT_APP_API_BASE}/api/marketplace/getCards/${listId}`
        );
   
        const userCardIds = collectionResponse.data; // Should be an array
      console.log('8000 userCardIds',userCardIds)
        if (!Array.isArray(userCardIds) || userCardIds.length === 0) {
          setError("No cards found in this collection.");
          return;
        }
     console.log('userCardIds',userCardIds)
        // Fetch details for those userCardIds
        const cardsResponse = await axios.put(
          `${process.env.REACT_APP_API_BASE}/getMultipleUserCards`,
          { userCardIds: userCardIds },  // ✅ Now sending `ids` in the body
         
        );
         console.log('cardsResponse.data',cardsResponse.data)
        setCards(cardsResponse.data);

      } catch (error) {
        console.error("Error fetching collection:", error);
        setError("Error fetching collection or cards.");
      } finally {
        setLoading(false);
      }
    };

    fetchCollection();
  }, [listId]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <section className='grid'>
      <div className="contentfront">
        <div className='justify top-page'>
          <div>
         
          <h1>MarketPlace</h1>

        
            <FullCardGrid
              setCards={setCards}
              cards={cards}
              groupedCards={[]}
              viewAsGrid={false}
              viewOnly={true}
              cardGridType={'CardGridSell'}
              
            />
          
          </div>
        </div>
      </div>
    </section>
  );
};
export default WantListViewer